import React from 'react';

const Footer = () => {
  const legalPointsCol1 = [
    "- Soy un Independent LactiGo Affiliate y no un empleado oficial de LactiGo Inc.",
    "- Los resultados individuales pueden variar significativamente según cada persona.",
    "- Esta información no constituye asesoramiento médico, diagnóstico o tratamiento.",
    "- Para preguntas médicas específicas, consulte siempre a un profesional de salud calificado.",
    "- Revise el Income Disclosure Statement oficial en LactiGo.com para información transparente sobre ingresos."
  ];

  const legalPointsCol2 = [
    "- LactiGo Gel está formulado exclusivamente para uso humano - no veterinario.",
    "- Al proporcionar su información, consiente recibir comunicaciones relacionadas con LactiGo.",
    "- Puede retirar su consentimiento y cancelar comunicaciones en cualquier momento.",
    "- Esta página web es operada independientemente y no representa oficialmente a LactiGo Inc.",
    "- Toda la información sobre ingredientes se basa en literatura científica y etiquetas oficiales del producto."
  ];

  return (
    <footer id="contact" className="py-5 text-white" style={{ backgroundColor: '#000022' }}>
      <div className="container">
        <div className="mb-5">
          <h5 className="fw-bold text-center">📋 Información Legal y Transparente</h5>
          <div className="row mt-4 text-start" style={{ fontSize: '0.8rem', color: '#adb5bd' }}>
            <div className="col-md-6">
              {legalPointsCol1.map((point, index) => (
                <p key={index} className="mb-1">{point}</p>
              ))}
            </div>
            <div className="col-md-6">
              {legalPointsCol2.map((point, index) => (
                <p key={index} className="mb-1">{point}</p>
              ))}
            </div>
          </div>
        </div>

        <hr style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} />

        <div className="text-center mt-5">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
            <img src="/images/dannyvargas_foto_perfil.png" alt="Danny Vargas" style={{ borderRadius: '50%', width: '100px', height: '100px', objectFit: 'cover' }} />
            <h2 className="fw-bold">Danny Vargas</h2>
          </div>
          <p>Potencia tu recuperación, maximiza tu rendimiento.</p>
          <div className="my-4">
            <button type="button" className="text-white mx-3 fs-4" style={{ background: 'none', border: 'none' }} aria-label="Twitter"><i className="bi bi-twitter"></i></button>
            <button type="button" className="text-white mx-3 fs-4" style={{ background: 'none', border: 'none' }} aria-label="Facebook"><i className="bi bi-facebook"></i></button>
            <button type="button" className="text-white mx-3 fs-4" style={{ background: 'none', border: 'none' }} aria-label="Instagram"><i className="bi bi-instagram"></i></button>
          </div>
          <a href="https://elsecretodelosatletas.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">
            <p className="mb-0">&copy; {new Date().getFullYear()} elsecretodelosatletas.com. Todos los derechos reservados.</p>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;